<template>
    <div class="register-popup-container">
        <div class="stick_popup">
            <div class="stick_popup__header">
                <img src="landing_page/img/close.svg" @click.prevent="closeExitPopup()" alt="">
                <h2>{{ $t('landing_page.components.exit_intent_popup.enter_your_email') }}</h2>
            </div>
            
            <div class="stick_popup__body">
                <template v-if="!success">
                    <div class="stick_popup__form">
                        <div class="input-wrap">
                            <input v-model="email" type="text" oninput="this.setAttribute('value', this.value);" value="">
                            <label for="">{{ $t('landing_page.components.exit_intent_popup.email_address') }}</label>
                        </div>
                        <button :disabled="!emailValid" @click.prevent="getDiscount()" class="btn btn-black">{{ $t('landing_page.components.exit_intent_popup.yes_i_want_discount') }}</button>
                        <a @click.prevent="closeExitPopup()">{{ $t('landing_page.components.exit_intent_popup.no_thanks') }}</a>
                    </div>
                </template>
                <template v-else>
                    <div class="stick_popup__success">
                        <p>{{ $t('landing_page.components.exit_intent_popup.discount_applied') }}</p>

                        <button @click.stop.prevent="showRegisterForm()" class="btn btn-black">{{ $t('landing_page.components.exit_intent_popup.finish_signing_up') }}</button>

                        <div class="register-popup-contents__bulletpoints">
                            <div class="register-popup-contents__bulletpoint">
                                <img src="/img/check-primary.svg" alt="">
                                <p>{{ $t('getting_started.14_day_free_trial') }}</p>
                            </div>
                            <div class="register-popup-contents__bulletpoint">
                                <img src="/img/check-primary.svg" alt="">
                                <p>{{ $t('getting_started.no_card_required') }}</p>
                            </div>
                            <div class="register-popup-contents__bulletpoint">
                                <img src="/img/check-primary.svg" alt="">
                                <p>{{ $t('getting_started.cancel_anytime') }}</p>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
        },
        data() {
            return {
                email: "",
                success: false,
            }
        },
        methods: {
            getDiscount() {
                let url =  `/guest/get-discount`;

                axios.post(url, {email: this.email}).then(function (response) {
                    console.log('exit popup');
                }).then(function(response) {
                    this.success = true;
                }.bind(this));
            },
            closeExitPopup() {
                this.$emit('closed');
            },
            showRegisterForm() {
                this.$emit('show_register_form', this.email);
            }
        },
        mounted() {
          
        },
        computed: {
            emailValid() {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(this.email).toLowerCase());
            },
        }
    }
</script>
